import { FC, ReactNode, useRef, useState } from "react";
import { Tooltip } from "antd";

interface OverflowTooltipProps {
    children: ReactNode;
    title?: ReactNode;
    className?: string;
}

export const OverflowTooltip: FC<OverflowTooltipProps> = ({
    children,
    title,
    className
}) => {

    const textRef = useRef<HTMLSpanElement>(null);

    const [isOverflow, setIsOverflow] = useState(false);


    const handleMouseEnter = () => {
        const element = textRef.current;

        if (!element) return;

        setIsOverflow(
            element.scrollWidth > element.clientWidth
        );
    };


    return (
        <Tooltip
            title={isOverflow ? title : undefined}
            placement="top"
            autoAdjustOverflow={false}
            getPopupContainer={() => document.body}
        >
            <span
                ref={textRef}
                className={className}
                onMouseEnter={handleMouseEnter}
            >
                {children}
            </span>
        </Tooltip>
    );
};